<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-row dense class="pt-6">
      <v-col cols="12" sm="12" md="12" lg="4">
        <v-text-field class="search-field" v-model="search" prepend-icon="mdi-magnify" label="Search..." single-line
          solo hide-details />
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="8">
        <ul class="my-3 my-lg-0">
          <li v-for="(value, key) in commissions?.summary" :key="key">
            <span>{{ key }}</span>
            <span>
              {{ formatSummaryValue(value) }} <strong>({{ formatSummaryTotal(value) }})</strong>
            </span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable liveTradeTable depositTabTable pb-3"
            :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-data-table :search="search" :headers="dynamicHeaders" :items="formattedInvestorOrders"
              :items-per-page="6">
              <template v-slot:item.LoginView="{ item }">
                {{ item.investor_account }}
              </template>
              <template v-slot:item.TotalOrder="{ item }">
                {{ item.stats.orders.period }} ({{ item.stats.orders.total }})
              </template>
              <template v-slot:item.TotalLot="{ item }">
                {{ item.stats.lot.period }} ({{ item.stats.lot.total }})
              </template>
              <template v-slot:item.TotalProfit="{ item }">
                {{ formatProfit(item.stats.profit.period) }} ({{ formatProfit(item.stats.profit.total) }})
              </template>
              <template v-slot:item.ProfitShare="{ item }">
                {{ commissions.profitSharePercentage }}%
              </template>
              <template v-slot:item.CommissionView="{ item }">
                {{ formatProfit(item.stats.commission.period) }} ({{ formatProfit(item.stats.commission.total) }})
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { MAM__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      search: "",
      baseHeaders: [
        { text: "Login", value: "LoginView" },
        { text: "Order (Total)", value: "TotalOrder" },
        { text: "Lot (Total)", value: "TotalLot" },
        { text: "Profit (Total)", value: "TotalProfit" },
        { text: "Profit Share", value: "ProfitShare" },
        { text: "Commission", value: "CommissionView" },
      ],
    };
  },

  computed: {
    ...mapState("mam", ["commissions"]),

    formattedInvestorOrders() {
      return this.commissions?.investorOrders || [];
    },

    timePrefix() {
      if (!this.commissions?.summary) return '';
      const firstKey = Object.keys(this.commissions?.summary)[0];
      return firstKey.split(' ')[0] + ' ' + firstKey.split(' ')[1];
    },

    dynamicHeaders() {
      return this.baseHeaders.map(header => {
        if (['LoginView', 'ProfitShare'].includes(header.value)) {
          return header;
        }
        return {
          ...header,
          text: this.timePrefix ? `${this.timePrefix} ${header.text}` : header.text
        };
      });
    }
  },

  methods: {
    ...mapActions("mam", [MAM__ACTIONS.COMMISSIONSTAB]),

    formatProfit(value) {
      return value ? value.toFixed(2) : '0.00';
    },

    formatSummaryValue(value) {
      return value.split(' ')[0];
    },

    formatSummaryTotal(value) {
      return value.match(/\(([^)]+)\)/)[1];
    },
  },

  async mounted() {
    await this[MAM__ACTIONS.COMMISSIONSTAB](this.$route.query.account);
  },
};
</script>